// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"05cb70b6","887":"4f74a1c2"}[chunkId] + ".chunk.js";
};